<style>

.stack-plan .text-terrace {
    color: #7cab3e;
}

.stack-plan .text-pre {
    color: #376099;
}

.stack-plan .stack-plan {
    font-size: 1rem;
    margin-top: 10rem;
}

.stack-plan .stack-lines div {
    padding: .15rem;
    border-bottom: 1px solid gray;
    /* position: relative; */
}
.stack-plan .stack-lines div.hide {
    padding: .15rem .15rem 0 .15rem;
    border-bottom: 0px solid gray;
}

.stack-plan .stack-image,
.stack-plan .stack-details {
    border-bottom: 1px solid #333;
}

.stack-plan .small {
    font-size: .75rem;
}
.stack-plan div.slim {
    font-size: .675rem;
    padding:0 .15rem .15rem .15rem;
    color: #ccc;

    /* position: absolute; top:200px; right:100px; */
}

.stack-plan div.slim a{
  display: flex;
  align-items: center;
}
.stack-plan div.slim a img{
  padding-right: 3px;
  height: 6px;
  opacity:.5;
}
.stack-plan .legend {
    line-height: .9rem;
}

.stack-plan .leased {
    /* opacity: .25; */
    color: #5C5B5C;
}

</style>

<template>

<div class="md:w-container mx-auto p-5 md:p-0 stack-plan">

    <div class="flex flex-col stack-plan">


        <div class="block md:flex">
            <div class="w-full md:w-1/3 stack-details">

                <div class="flex flex-wrap">

                    <div class="stack-lines flex flex-wrap">
                        <div class="w-1/2 text-gray">FLOOR</div>
                        <div class="w-1/2 text-gray"> SQ FT</div>

                        <div class="w-1/2">26TH</div>
                        <div class="w-1/2">2,492 RSF</div>
                        <div class="w-1/2">25TH</div>
                        <div class="w-1/2">2,492 RSF</div>
                        <div class="w-1/2">24TH</div>
                        <div class="w-1/2">2,483 RSF</div>
                        <div class="w-1/2">23RD</div>
                        <div class="w-1/2">2,483 RSF</div>
                        <div class="w-1/2 leased">22ND</div>
                        <div class="w-1/2 leased">
                            <!-- 2,473 RSF -->
                            LEASED
                        </div>
                        <div class="w-1/2 hide">21ST</div>
                        <div class="w-1/2 hide">2,483 RSF</div>
                        <div class="w-full slim"><a href="prebuilt/21stfloorpre.pdf">
                        <img src="images/download.svg"/> EXPEDITED BUILD OUT AVAILABLE</a></div>

                        <div class="w-1/2 hide">20TH</div>
                        <div class="w-1/2 hide">2,483 RSF</div>
                        <div class="w-full slim"><a href="prebuilt/20thfloorpre.pdf">
                        <img src="images/download.svg"/> FURNISHED PRE-BUILT</a></div>

                        <div class="w-1/2 leased">19TH</div>
                        <div class="w-1/2 leased">
                          <!-- 2,682 RSF -->
                          LEASED
                        </div>
                        <div class="w-1/2 leased">18TH</div>
                        <div class="w-1/2 leased">
                          <!-- 2,682 RSF -->
                          LEASED
                        </div>
                        <div class="w-1/2 leased">17TH</div>
                        <div class="w-1/2 leased">
                          <!--2,682 RSF -->
                          LEASED
                        </div>
                        <div class="w-1/2 leased">16TH</div>
                        <div class="w-1/2 leased">
                          <!-- 3,051 RSF -->
                          LEASED
                        </div>
                        <div class="w-1/2 hide">15TH </div>
                        <div class="w-1/2 hide">3,051 RSF </div>
                        <div class="w-full slim"><a href="prebuilt/15thfloorpre.pdf">
                          <img src="images/download.svg"/> EXPEDITED BUILD OUT AVAILABLE</a></div>

                        <div class="w-1/2 leased">14TH</div>
                        <div class="w-1/2 leased">
                          <!-- 3,051 RSF -->
                          LEASED
                        </div>
                        <div class="w-1/2">12TH</div>
                        <div class="w-1/2">3,482 RSF</div>
                        <div class="w-1/2">11TH</div>
                        <div class="w-1/2">3,482 RSF</div>
                        <div class="w-1/2 text-terrace hide">10TH</div>
                        <div class="w-1/2 hide">3,482 RSF</div>
                        <div class="w-full slim"><a href="prebuilt/10thfloorpre.pdf">
                          <img src="images/download.svg"/> EXPEDITED BUILD OUT AVAILABLE</a></div>

                        <div class="w-1/2">9TH</div>
                        <div class="w-1/2">3,850 RSF</div>

                        <div class="w-1/2 hide">8TH</div>
                        <div class="w-1/2 hdie">3,850 RSF</div>
                          <div class="w-full slim"><a href="prebuilt/8thfloorpre.pdf">
                            <img src="images/download.svg"/> PRE-BUILT</a></div>

                        <div class="w-1/2 text-terrace">7TH</div>
                        <div class="w-1/2 ">3,850 RSF</div>

                        <div class="w-1/2 hide">6TH</div>
                        <div class="w-1/2 hide">4,524 RSF</div>
                        <div class="w-full slim"><a href="prebuilt/6thfloorpre.pdf">
                          <img src="images/download.svg"/> FURNISHED PRE-BUILT</a></div>

                        <div class="w-1/2">5TH</div>
                        <div class="w-1/2">4,524 RSF</div>
                        <div class="w-1/2">4TH</div>
                        <div class="w-1/2">4,524 RSF</div>
                        <div class="w-1/2 hide">3RD</div>
                        <div class="w-1/2 hide">4,524 RSF </div>
                        <div class="w-full slim"><a href="prebuilt/3rdfloorpre.pdf">
                          <img src="images/download.svg"/> EXPEDITED BUILD OUT AVAILABLE</a></div>
                        <div class="w-1/2 text-terrace">2RD</div>
                        <div class="w-1/2">4,524 RSF</div>

                        <div class="w-full text-terrace small">TERRACE FLOORS</div>





                        <!-- <div class="w-1/2 text-pre small">PRE-BUILT FLOORS</div> -->


                    </div>
                </div>
                <div class="mt-4 hidden sm:block"> <a href="https://customize.thesix56.com/floors" class="button">Customize Layout</a></div>

            </div>

            <div class="w-full md:w-2/3 pl-20 stack-image">
                <img src="/images/stack-plan-original.png" />
            </div>
        </div>

        <!-- <div class="block text-center">


      </div> -->


        <div class="text-gray pt-10 small">
            <p>
                TENANT-EXCLUSIVE LOUNGE AND CONCIERGE SERVICE</p>
            <br/>
            <p>
                TENANT-EXCLUSIVE BOARDROOM
            </p>
            <p>
                CENTRAL PARK VIEWS FROM THE TOWER FLOORS</p>
            <br/>
            <p>
                SLAB HEIGHTS OF 13’6”
            </p>
        </div>

    </div>

</div>

</template>

<script>

export default {
    name: 'stack-plan',

}

</script>
